import { useMutation } from '@tanstack/react-query';
import type {
  ForgetPasswordData,
  LoginData,
  RegisterFcmTokenData,
  ResendEmailVerificationData,
  ResetPasswordData,
  SignUpData,
  VerifyEmailData,
  VerifyResetPasswordData,
} from '../types/auth';
import {
  checkStatus,
  forgetPassword,
  registerFcmToken,
  resendEmailVerification,
  resetPassword,
  signInUser,
  signOutUser,
  signUpUser,
  verifyEmail,
  verifyResetPasswordCode,
} from '../services/authService';

const useLogin = () => {
  return useMutation({
    mutationFn: (data: LoginData) => signInUser(data),
  });
};

const useSignUp = () => {
  return useMutation({
    mutationFn: (data: SignUpData) => signUpUser(data),
  });
};

const useSignOut = () => {
  return useMutation({
    mutationFn: () => signOutUser(),
  });
};

const useEmailVerification = () => {
  return useMutation({
    mutationFn: (data: VerifyEmailData) => verifyEmail(data),
  });
};

const useForgetPassword = () => {
  return useMutation({
    mutationFn: (data: ForgetPasswordData) => forgetPassword(data),
  });
};

const useVerifyResetPassword = () => {
  return useMutation({
    mutationFn: (data: VerifyResetPasswordData) =>
      verifyResetPasswordCode(data),
  });
};

const useResetPassword = () => {
  return useMutation({
    mutationFn: (data: ResetPasswordData) => resetPassword(data),
  });
};

const useResendEmailVerification = () => {
  return useMutation({
    mutationFn: (data: ResendEmailVerificationData) =>
      resendEmailVerification(data),
  });
};

const useCheckStatus = () => {
  return useMutation({
    mutationFn: () => checkStatus(),
  });
};

const useRegisterFcmToken = () => {
  return useMutation({
    mutationFn: (data: RegisterFcmTokenData) => registerFcmToken(data),
  });
};

export {
  useLogin,
  useSignUp,
  useSignOut,
  useEmailVerification,
  useForgetPassword,
  useVerifyResetPassword,
  useResetPassword,
  useResendEmailVerification,
  useCheckStatus,
  useRegisterFcmToken,
};
